module.exports = __webpack_public_path__ + "static/media/launcher.e07385f6.png";